
import { Constants } from "../libs/Constants";
import { get, getList } from "../libs/dbFunctions";
import { convertUTCDateInTimeZone } from "../libs/utils.js";
const moment = require("moment");

// loadRecentStockPrice will retrieve the most recent opening/closing stock price for the given stock symbol
export async function loadRecentStockPrice(stockSymbol) {
    if (!stockSymbol) {
        throw "Stock symbol required to load recent stock price data";
    }

    let data = await get(
        Constants.dbTypes.STOCK_PRICES,
        stockSymbol
    );

    if (data.date === "Invalid Date" || data.open === "NA") {
        throw "Could not get valid recent stock price, make sure the current company has a valid stock ticker symbol for its code.";
    }

    // show either closing or opening stock price
    if (data.close) {
        data.displayPrice = data.close;
        data.priceDesc = "Closing";
        if (moment(data.date).isSame(moment(), 'day')) {
            data.priceDesc = "Recent";
        } 
    } else {
        data.displayPrice = data.open;
        data.priceDesc = "Opening";
    }

    return data;
}

// loadRecentStockPrice will get a closing price near date
export async function loadStockPriceNearDate(company, targetDate) {
    if (!targetDate || !company) {
        throw "Invalid request to get stock price data";
    }

    let targetDateStart = convertUTCDateInTimeZone(targetDate, company.timezone).add(-1, "month");
    let targetDateEnd = convertUTCDateInTimeZone(targetDate, company.timezone);

    let params = {
        stockTickerSymbol: company.code,
        fromDate: targetDateStart.format(Constants.DATEFORMAT.YYYYMMDD), // get stock price data from 1 month ago until now to find the most recent market day
        toDate: targetDateEnd.format(Constants.DATEFORMAT.YYYYMMDD),
        period: "day",
    };

    let stockPriceList = await getList(
        Constants.dbTypes.STOCK_PRICES,
        company,
        params,
    );

    if (!stockPriceList.length) {
        throw "Unable to load stock price for target date"
    }

    let mostRecentPrice = stockPriceList[stockPriceList.length - 1];

    mostRecentPrice.displayPrice = mostRecentPrice.close;
    mostRecentPrice.priceDesc = "Closing"
    return mostRecentPrice;
}